import { messageFormat as message } from '@clubmed/utils';
export function getCountOptions(
  labels: PluralizedLabel,
  initial: number,
  limit: number,
): SelectProps {
  const options = [];
  const messageFormat = message(labels);

  for (let count = initial; count <= limit; count++) {
    options.push({
      label: messageFormat.format({
        count,
      }),
      value: count,
    });
  }

  return options;
}
export function getAdultsOptions(
  selectAdultsLabels: PluralizedLabel,
  initial: number = 1,
  limit: number = 6,
) {
  return getCountOptions(selectAdultsLabels, initial, limit);
}
export function getChildrenOptions(
  selectChildrenLabels: PluralizedLabel,
  initial: number = 0,
  limit: number = 6,
) {
  return getCountOptions(selectChildrenLabels, initial, limit);
}
export type DurationOptions = Array<{
  name: string;
  label: string;
  value: string;
}>;
export function getDurationOptions(
  messageFormat: string | PluralizedLabel,
  durations: Array<number>,
  key: string = 'duration',
): DurationOptions {
  const durationMessage = message(messageFormat);
  return durations.map((duration) => {
    return {
      name: durationMessage.format({
        [key]: duration,
      }),
      label: durationMessage.format({
        [key]: duration,
      }),
      value: duration.toString(),
    };
  });
}
